import {
    Flex,
    Box,
    Text,
    Button,
    HStack,
} from "@chakra-ui/react";
import  { Save } from "lucide-react";
import { toaster } from "../../../components/toaster";
import ActivityToast from "../../../components/ActivityToast";
import { Import } from "lucide-react";

const PageHeader = ({
    title,
    subtitle,

    primaryLabel,
    secondaryLabel,

    onPrimaryClick,
    onSecondaryClick,

    primaryIcon = Save,
    secondaryIcon = null,

    primaryDisabled = false,
    primaryDisabledTitle = "Action unavailable",
    primaryDisabledMessage = "",
}) => {
    const PrimaryIcon =
        primaryIcon;

    const SecondaryIcon =
        secondaryIcon;

    const handlePrimaryClick =
        () => {
            if (
                primaryDisabled
            ) {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="warning"
                            title={
                                primaryDisabledTitle
                            }
                            description={
                                primaryDisabledMessage
                            }
                            timestamp="Just now"
                        />
                    ),
                });

                return;
            }

            onPrimaryClick?.();
        };

    return (
        <Flex
            justify="space-between"
            align={{
                base: "flex-start",
                lg: "center",
            }}
            direction={{
                base: "column",
                lg: "row",
            }}
            gap={6}
            mb={8}
        >
            <Box>
                <Text
                    fontSize="33px"
                    fontWeight="700"
                    color="#2453FF"
                    lineHeight="1"
                >
                    {title}
                </Text>

                <Text
                    mt={2}
                    color="gray.500"
                >
                    {subtitle}
                </Text>
            </Box>

            {(primaryLabel ||
                secondaryLabel) && (
                <HStack>
                    {secondaryLabel && (
                        <Button
                            variant="outline"
                            borderRadius="12px"
                            onClick={
                                onSecondaryClick
                            }
                        >
                            {SecondaryIcon && (
                                <SecondaryIcon
                                    size={18}
                                />
                            )}

                            {
                                secondaryLabel
                            }
                        </Button>
                    )}

                    {primaryLabel && (
                        <Button
                            bg="#2453FF"
                            color="white"
                            borderRadius="12px"
                            opacity={
                                primaryDisabled
                                    ? 0.6
                                    : 1
                            }
                            cursor={
                                primaryDisabled
                                    ? "not-allowed"
                                    : "pointer"
                            }
                            _hover={{
                                bg: primaryDisabled
                                    ? "#2453FF"
                                    : "#1E46D8",
                            }}
                            onClick={
                                handlePrimaryClick
                            }
                        >
                            {PrimaryIcon && (
                                <PrimaryIcon
                                    size={18}
                                />
                            )}

                            {
                                primaryLabel
                            }
                        </Button>
                    )}
                </HStack>
            )}
        </Flex>
    );
};

export default PageHeader;